import React from 'react';
import { peopleNeeds, purposeUses } from '../data/content';
import { SunRays } from './decor/SunRays';
export function Purpose() {
  return <section aria-labelledby="purpose-title" className="relative overflow-hidden bg-cream-deep" data-id="element-265" data-mp="2ova1s5lx638k">
      <SunRays className="pointer-events-none absolute -left-48 -bottom-48 w-[520px] text-gold/20" data-id="element-266" data-mp="33jo2a9vv5fly" />
      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 lg:py-28" data-id="element-267" data-mp="2yqbq4z8df1a3">
        <h2 id="purpose-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-268" data-mp="3chgjxkp24zci">
          Viel mehr als eine Sammlung von Druckvorlagen
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-269" data-mp="3mfwcls3qggo4">
          Es ist leicht, sich noch eine christliche Ressource herunterzuladen und sie dann auf dem Computer zu vergessen. Dafür wurde dieses Paket
          nicht gemacht.
        </p>
        <p className="mt-8 font-display text-3xl text-coral sm:text-4xl" data-id="element-270" data-mp="1n43chmlnev76">Es wurde gemacht, um genutzt zu werden.</p>
        <ul className="mt-4 space-y-1" data-id="element-271" data-mp="afpn1wtoq513">
          {purposeUses.map(u => <li key={u} className="font-display text-2xl text-navy sm:text-[28px]" data-id="element-272" data-mp="feacr2bb96ba">
              {u}
            </li>)}
        </ul>
        <p className="mt-8 text-lg leading-relaxed text-ink-soft" data-id="element-273" data-mp="jet5cyl12gej">Damit aus ganz gewöhnlichen Momenten Gelegenheiten werden, jemanden auf Christus hinzuweisen.</p>

        <div className="mt-12 rounded-[28px] bg-white p-8 text-left shadow-card sm:p-10" data-id="element-274" data-mp="t5xl40ij25af">
          <p className="text-lg font-bold text-navy" data-id="element-275" data-mp="y4s0stl77dqb">Denn genau jetzt gibt es Menschen um dich herum, die vielleicht dringend Folgendes brauchen:</p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-276" data-mp="1356ash6d0xqz">
            {peopleNeeds.map((n, i) => <li key={n} className={`rounded-xl bg-cream px-5 py-3.5 font-semibold text-navy ${i === peopleNeeds.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-277" data-mp="1745gi3zx0yjh" data-mpi={i}>
                {n}
              </li>)}
          </ul>
        </div>

        <p className="mt-12 font-display text-4xl italic text-coral sm:text-5xl" data-id="element-278" data-mp="g1joecp0onm0">Was wäre, wenn genau du ihnen diese Botschaft bringst?</p>
      </div>
    </section>;
}